import request from '../request'

export default {
  sendMapCapture(data) {
    return request.post('image', data)
  }
}
